"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var Input_1 = require("../Input/Input");
var InputLabel_1 = require("../InputLabel/InputLabel");
var TextField_style_1 = __importDefault(require("./TextField.style"));
/**
 * TextField atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-inputs-textfield--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/TextField Source}
 */
var TextField = function (_a) {
    var className = _a.className, disabled = _a.disabled, errorText = _a.errorText, helperText = _a.helperText, id = _a.id, inputRef = _a.inputRef, label = _a.label, labelAdditionalInfo = _a.labelAdditionalInfo, link = _a.link, maxWidth = _a.maxWidth, onBlur = _a.onBlur, onFocus = _a.onFocus, width = _a.width, otherProps = __rest(_a, ["className", "disabled", "errorText", "helperText", "id", "inputRef", "label", "labelAdditionalInfo", "link", "maxWidth", "onBlur", "onFocus", "width"]);
    var classes = (0, TextField_style_1.default)();
    var _b = __read((0, react_1.useState)(false), 2), isFocused = _b[0], setFocus = _b[1];
    var handleOnBlur = function (event) {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
        setFocus(false);
    };
    var handleOnFocus = function (event) {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
        setFocus(true);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { width: width, maxWidth: maxWidth }, className: (0, classnames_1.default)(classes.root, className) }, { children: [label && ((0, jsx_runtime_1.jsx)("label", { children: (0, jsx_runtime_1.jsx)(InputLabel_1.InputLabel, { label: label, link: link, additionalInfo: labelAdditionalInfo, disabled: disabled }) })), renderInputField(), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.helperTextContainer }, { children: (helperText || errorText) && renderHelperText() }))] })));
    function renderInputField() {
        return ((0, jsx_runtime_1.jsx)(Input_1.Input, __assign({ inputRef: inputRef, onBlur: handleOnBlur, onFocus: handleOnFocus, width: '100%', hasError: !!errorText, disabled: disabled }, otherProps)));
    }
    function renderHelperText() {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(classes.helperText, !!errorText && classes.error, !errorText && isFocused && classes.visible) }, { children: errorText || helperText })));
    }
};
exports.TextField = TextField;
